import { Form, Row } from "antd";
import TextArea from "antd/es/input/TextArea";
import { useMemo } from "react";
import { useTextFieldRules } from "../../hooks/useTextFieldRules";

export const OptionalValues = () => {
  const autoSize = useMemo(() => ({ minRows: 4 }), []);

  const { longTextRules } = useTextFieldRules();

  const formItemsMap = useMemo(
    () => [
      {
        label: "Immediate Actions Taken",
        name: "immediateActions",
        placeholder:
          "Steps were taken immediately to address the upset client and diffuse the situation",
      },
      {
        label: "Communication with the Client",
        name: "communication",
        placeholder:
          "Communication made with the client to address their concerns, including phone calls, emails, or in-person interactions",
      },
      {
        label: "Resolution Offered",
        name: "resolutionOffered",
        placeholder:
          "Resolution proposed to the client to rectify the situation",
      },
      {
        label: "Follow-up Actions",
        name: "followupActions",
        placeholder:
          "Any follow-up actions planned or taken to ensure the client’s satisfaction and prevent similar incidents in the future",
      },
      {
        label: "Preventative Measures",
        name: "preventativeMeasures",
        placeholder:
          "Any measures implemented or recommended to prevent similar incidents in the future",
      },
    ],
    [],
  );

  return (
    <Row className="d-block w-100 pb-6">
      <p className="mt-0 mb-4 text w-500">
        Handling of the Situation (Optional)
      </p>
      {formItemsMap.map((item: any) => (
        <Form.Item
          label={item.label}
          name={item.name}
          key={item.name}
          rules={longTextRules}
        >
          <TextArea autoSize={autoSize} placeholder={item.placeholder} />
        </Form.Item>
      ))}
    </Row>
  );
};
